import { createRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { ProductForm } from '../components/productForm';
import { ProductList } from '../components/productList';
import { useDeleteProduct, useProducts, useSaveProduct } from '../hooks/useProducts';
import type { ProductFormData } from '../types/product';
import { protectedLayoutRoute } from './protectedLayout';

function UsedDronesPage() {
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState<ProductFormData | null>(null);

  const { data: products = [], isLoading } = useProducts('used-drones');
  const saveMutation = useSaveProduct();
  const deleteMutation = useDeleteProduct();

  const handleSubmit = async (data: ProductFormData) => {
    saveMutation.mutate(data, {
      onSuccess: () => {
        setShowForm(false);
        setEditingProduct(null);
      },
    });
  };

  const handleEdit = (product: ProductFormData) => {
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleDelete = (product: ProductFormData, onSuccess: () => void) => {
    if (!product.slug) return;
    deleteMutation.mutate({ slug: product.slug, category: 'used-drones' }, { onSuccess });
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingProduct(null);
  };

  if (showForm) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
            {editingProduct ? 'Editar Drone Usado' : 'Novo Drone Usado'}
          </h1>
          <p className="mt-1 text-sm text-muted-foreground sm:text-base">
            {editingProduct
              ? 'Atualize as informações do drone'
              : 'Adicione um drone usado ao catálogo'}
          </p>
        </div>
        <ProductForm
          initialData={editingProduct || { category: 'used-drones' }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          lockedCategory
          isLoading={saveMutation.isPending}
        />
      </div>
    );
  }

  return (
    <ProductList
      products={products}
      isLoading={isLoading}
      category="used-drones"
      onAddNew={() => setShowForm(true)}
      onEdit={handleEdit}
      onDelete={handleDelete}
      isDeleting={deleteMutation.isPending}
    />
  );
}

export const usedDronesRoute = createRoute({
  getParentRoute: () => protectedLayoutRoute,
  path: '/used-drones',
  component: UsedDronesPage,
});
